import http from "../../http-common";

class CutoffLunchMenuService {

    getAll(data) {
        return http.post("/admin/getCutoffLunchMenu", data);
    }

    save(data) {
        return http.post("/admin/saveCutoffLunchMenu", data);
    }

    delete(id) {
        return http.delete(`/admin/cutoffLunchMenu/${id}`);
    }

    // Schedules: daily / recurring cutoffs, automatic or manual
    getSchedules() {
        return http.post("/admin/getCutoffLunchSchedule", {});
    }

    saveSchedule(data) {
        return http.post("/admin/saveCutoffLunchSchedule", data);
    }

    toggleSchedule(id, isActive) {
        return http.post(`/admin/cutoffLunchSchedule/${id}/toggle`, { ISACTIVE: isActive });
    }

    generateSchedule(id) {
        return http.post(`/admin/cutoffLunchSchedule/${id}/generate`, {});
    }

    deleteSchedule(id) {
        return http.delete(`/admin/cutoffLunchSchedule/${id}`);
    }

}

export default new CutoffLunchMenuService();
